import React, { FC } from "react";

import flex from "../../../../../../styles/flex";

import { IFlightLookupItem } from "../../../../../../logic/api";

import { useDate } from "../../../../../../utility/useDate";

interface FlightResultProps {
    item: IFlightLookupItem,
    selectFlight: (item: IFlightLookupItem) => void,
}

const FlightResult: FC<FlightResultProps> = ({ item, selectFlight }: FlightResultProps) => {
    const { toFormattedDateString, toFormattedTimeString } = useDate();

    const flightDate = new Date(item.relativeDateTime);

    return <div onClick={() => selectFlight(item)} style={{ padding: 10, backgroundColor: "#fff", borderBottom: "solid 1px lightgray", cursor: "pointer", textAlign: "left" }}>

        <div style={flex.flexRows}>
            <div style={flex.flexFill}>
                <div>
                    <span style={{ color: "black", fontWeight: "bold", fontSize: 18 }}>{item.airline}{item.flight_no}</span>
                </div>
                <div>
                    <span style={{ color: "black", fontSize: 14 }}>{item.terminal}</span>
                </div>
                <div>
                    <span style={{ color: "black", fontSize: 14 }}>{item.airline} [{item.transfer} &gt; {item.airport}]</span>
                </div>

            </div>

            <div style={flex.flexAuto}>
                <div style={{ textAlign: "right" }}>
                    <span style={{ color: "black", fontWeight: "bold", fontSize: 30 }}>{toFormattedTimeString(flightDate)}</span>
                    <div>
                        <b>{toFormattedDateString(flightDate)}</b>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default FlightResult;
